var Student = function (src) {
    var self = this;
    src = src || {};
    self.StudentId = src.StudentId || 0;
    self.StudentPicture = src.StudentPicture || '';
    self.FirstName = src.FirstName || '';
    self.CISNo = src.CISNo || '';
    self.MiddleInitial = src.MiddleInitial || '';
    self.LastName = src.LastName || '';
    self.DOBMonthYear = src.DOBMonthYear || '';
    self.PrimaryPhoneNumber = src.PrimaryPhoneNumber || '';
    self.PersonalEmailAddress = src.PersonalEmailAddress || '';
    self.FSPhoneNumber = src.FSPhoneNumber || '';
    self.FSEmailAddress = src.FSEmailAddress || '';
    self.JCStartDate = src.JCStartDate || '';
    self.JCStartDate2 = Date.parse('2004-05-01');
    self.PLCCertificateDate = src.PLCCertificateDate   || '';
    self.PLCCertificateRecieved = src.PLCCertificateRecieved || 0;
    self.JCCCC = src.JCCCC || 0;
    self.CenterName = src.CenterName || '';
    self.EducationLevel = src.EducationLevel || '';
    self.CredentialsList = src.Credentials  || [];
    self.Credentials = src.Credentials || '';
    self.StudentType = src.StudentType || '';
    self.TradesList = src.StudentTrade || [];
    self.StudentTrade = src.StudentTrade || '';
    self.StudentBio = src.StudentBio || '';
    self.Gender = src.Gender || '';
    self.Ethnicity = src.Ethnicity || '';
    self.PersonWithDisabilities = src.PersonWithDisabilities || 0;
    self.Veteran = src.Veteran || 0;
    self.EmploymentFirePlacement = src.EmploymentFirePlacement || 0;
    self.Employer = src.Employer || '';
    self.EmployerOther = src.EmployerOther || '';
    self.HiringAuthorityList = src.HiringAuthority  || [];
    self.HiringAuthority = src.HiringAuthority || '';
    self.PlacementDate = src.PlacementDate || '';
    self.SupervisorRemarks = src.SupervisorRemarks || '';
    self.JCGraduationDate = src.JCGraduationDate || '';
    self.ICSPositionList = src.ICSPosition || [];
    self.ICSPosition = src.ICSPosition || '';
    self.ICSTraineePositionList = src.ICSTraineePosition || [];
    self.ICSTraineePosition = src.ICSTraineePosition || '';
    self.Active = src.Active || 1;
    self.Deleted = src.Deleted || 0;
    self.Creator = src.Creator || '';
    self.LastModifiedBy = src.LastModifiedBy || '';
    self.CreatedDate = src.CreatedDate || new Date();
    self.CreatedDateString = src.CreatedDateString || '';
    self.CreatedBy = src.CreatedBy || '';
    self.LastUpdated = src.LastUpdated || new Date();
    self.LastUpdatedString = src.LastUpdatedString || '';
    self.LastUpdatedBy = src.LastUpdatedBy || '';
    self.UpdatingApp = src.UpdatingApp || '';
    self.PublicHours =src.PublicHours|| []; 
    self.FireHours = src.FireHours || [];
    self.CommunityHours = src.CommunityHours || [];
    self.PlacentType = src.PlacementType || '';
    self.JobTitle = src.JobTitle || '';
    self.JobLocations = src.JobLocations || '';
    self.Salary = src.Salary || 0;
    self.TotalPLCHours = src.TotalPLCHours || 0;
    return self;
};
Student.prototype.fullName = function () {
    return (this.LastName || '') + ', ' + (this.FirstName || '') + ' ' + this.MiddleInitial;
};
angular.module('jcsfApp').value('Student', Student);